import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI, getApiError } from '../services/api';
import { useTheme } from '../context/ThemeContext';
import { Lock, Loader2, CheckCircle } from 'lucide-react';

const SetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Las contraseñas no coinciden');
      return;
    }
    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await authAPI.setPassword({ token, password });
      setSuccess(true);
    } catch (err) {
      setError(getApiError(err, 'Error al establecer la contraseña'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 max-w-md w-full shadow-xl">
        {success ? (
          <div className="text-center">
            {isDarkMode ? (
              <img src="/sttora.png" alt="STTORA" className="h-12 mx-auto mb-4" />
            ) : (
              <div className="inline-block p-2 bg-gray-800 rounded-xl mb-4">
                <img src="/sttora.png" alt="STTORA" className="h-10" />
              </div>
            )}
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-3" />
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Contraseña Establecida</h2>
            <p className="text-gray-500 mb-6">Tu contraseña ha sido configurada exitosamente.</p>
            <button onClick={() => navigate('/login')}
              className="bg-orange-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-orange-700">
              Ir a Iniciar Sesión
            </button>
          </div>
        ) : (
          <>
            <div className="text-center mb-8">
              {isDarkMode ? (
                <img src="/sttora.png" alt="STTORA" className="h-12 mx-auto mb-4" />
              ) : (
                <div className="inline-block p-2 bg-gray-800 rounded-xl mb-4">
                  <img src="/sttora.png" alt="STTORA" className="h-10" />
                </div>
              )}
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Establecer Contraseña</h1>
              <p className="text-gray-500 dark:text-gray-400 mt-2">Crea una contraseña segura para tu cuenta</p>
            </div>
            {error && <div className="bg-red-50 dark:bg-red-900/30 text-red-600 text-sm p-3 rounded-xl mb-4">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="password" placeholder="Nueva Contraseña" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
              <input type="password" placeholder="Confirmar Contraseña" required value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
              <button type="submit" disabled={loading}
                className="w-full bg-orange-600 text-white py-3 rounded-xl font-semibold hover:bg-orange-700 disabled:opacity-50 flex items-center justify-center gap-2">
                {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Guardando...</> : 'Establecer Contraseña'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default SetPassword;
